/*
 * Module for the IRS 945 Form job criteria page
 */
rs.module("content/jobs/criteria/irs945form",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors, manualCodeValueKey) {

            var criteria = $.js(jsSelectors.criteria);

            var completionMethodSelect = criteria.js(jsSelectors.completionMethodSelect);
            var addressChangeCheckBox = criteria.js(jsSelectors.addressChangeCheckBox);
            var backupWithholdingTextBox = criteria.js(jsSelectors.backupWithholdingTextBox);
            var depositsTextBox = criteria.js(jsSelectors.depositsTextBox);
            var finalPaymentCheckBox = criteria.js(jsSelectors.finalPaymentCheckBox);
            var finalPaymentDateInput = criteria.js(jsSelectors.finalPaymentDateInput);

            // Get Select Helper for Select Lists where we're updating their options and properties
            var overpaymentAppliedToSelectHelper = selectHelper.getHelper(criteria.js(jsSelectors.overpaymentAppliedToSelect));

            // Register completionMethodSelect change event to hide/show appropriate fields
            completionMethodSelect.change(completionMethodSelectChanged);

            // Register finalPaymentDateInput change event to hide/show appropriate fields
            finalPaymentCheckBox.change(finalPaymentCheckBoxChanged);

            // Enable/disable fields based on completionMethodSelect changed
            function completionMethodSelectChanged() {
                var isManual = completionMethodSelect.val() === manualCodeValueKey.toString();

                if (isManual) {
                    addressChangeCheckBox.setChecked(false);
                    addressChangeCheckBox.prop('disabled', true);
                    backupWithholdingTextBox.clearErrors().val('').prop('disabled', true);
                    depositsTextBox.clearErrors().val('').prop('disabled', true);
                    overpaymentAppliedToSelectHelper.setValue('').setDisabled(true);
                    finalPaymentCheckBox.setChecked(false);
                    finalPaymentCheckBox.prop('disabled', true);
                    finalPaymentDateInput.clearErrors().val('').prop('disabled', true);
                }
                else {
                    addressChangeCheckBox.prop('disabled', false);
                    backupWithholdingTextBox.prop('disabled', false);
                    depositsTextBox.prop('disabled', false);
                    overpaymentAppliedToSelectHelper.setDisabled(false);
                    finalPaymentCheckBox.prop('disabled', false);
                }
            }

            // Enable/disable finalPaymentDateInput based on finalPaymentCheckBox changed
            function finalPaymentCheckBoxChanged() {

                if (finalPaymentCheckBox.is(":checked")) {
                    finalPaymentDateInput.prop('disabled', false);
                }
                else {
                    finalPaymentDateInput.clearErrors().val('').prop('disabled', true);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);